var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayReceivedOrderSection(_vm.order)
    ? _c(
        "section",
        [
          !_vm.includeCssClass ? _c("div", [_c("hr")]) : _vm._e(),
          _vm._v(" "),
          _c("div", { class: { "card panel-white": _vm.includeCssClass } }, [
            _c("div", { class: { "card-body": _vm.includeCssClass } }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("message.received_order.section_title")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.received_order.section_title2")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row no-gutters mt-3" }, [
                _c("div", { staticClass: "col-6 pr-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn h-100 btn-outline-info btn-block",
                      on: {
                        click: function($event) {
                          return _vm.openReportModal(_vm.order)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.button.report_problem")) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 pl-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn h-100 btn-info btn-block",
                      on: {
                        click: function($event) {
                          return _vm.openReceivedOrderModal(-1, _vm.order.id)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.button.received_order")) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("report-modal", { ref: "reportModal" }),
          _vm._v(" "),
          _c("received-order-modal", { ref: "receivedOrderModal" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-892489e0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-892489e0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/ReceivedOrderSection.vue
// module id = 1633
// module chunks = 0